import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpResponse,
	HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { get, pickBy } from 'lodash';
import { tap } from 'rxjs/operators';

@Injectable()
export class AnalyticsInterceptor implements HttpInterceptor {
	constructor() {}
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			tap(
				(res: HttpEvent<Response>) => {
					if (res instanceof HttpResponse) {
						// When opening a modal
						if (get(res.body, 'action') === 'render:modal') {
							const label =
								res.body.data.attributes && res.body.data.attributes.gaEventLabel
									? res.body.data.attributes.gaEventLabel
									: res.body.data.name;
							if (res.body.data.attributes.type === 'info-we-found-mvp') {
							} else {
							}
						}

						if (get(res.body, 'action') === 'render:popup') {
							if (res.body.data.name == 'Popup.TalkWithUs') {
								return;
							}
						}
					}
				},
				(err: any) => {
					if (err instanceof HttpErrorResponse) {
						if (err.status === 401) {
							// redirect to the login route
							// or show a modal
						}
					}
				}
			)
		);
	}

	setGtmObj(data) {
		let controlsKeys;
		switch (data.name) {
			case 'Popup.TalkWithUs':
				let controls = data.controls[0].attributes;
				controlsKeys = pickBy(controls, (value, key) => {
					return key.toLowerCase().indexOf('button') > -1 && value.visible;
				});
				// controlsKeys = filter(keys(controls), key => {
				//   return key.toLowerCase().indexOf("button") > -1;
				// });
				break;
			default:
				break;
		}

		return controlsKeys;
	}
}
